import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Utils from 'src/app/helpers/utils';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-dashboard-witnesses',
  templateUrl: './dashboard-witnesses.component.html',
  styleUrls: ['./dashboard-witnesses.component.scss'],
})
export class DashboardWitnessesComponent implements OnInit {
  witnessForm = this.formBuilder.group({
    name: [null, [Validators.required]],
    document: [null, [Validators.required, Utils.validateCpfCnpj]],
    email: [null, [Validators.required, Validators.email]],
  });

  permissionObj: PermissionValues = {
    canAdd: false,
    canChange: false,
    canDelete: false,
  };

  loading = true;
  witness: Witness = null;
  witnesses: Witness[] = [];
  addWitnesses = false;
  count = 0;
  offset = 0;
  constructor(
    private api: ApiService,
    private toast: ToastService,
    public formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.authService.canViewPage(['de_can_view_witnesses']);

    this.setPermissions();
    this.setBreadcrumb();
    this.getData();
  }

  async getData(page: number = 1) {
    try {
      const { data, count, offset } = await this.api.get({
        route: 'api/registration/witnesses/',
        params: {
          page: page,
        },
        token: true,
      });

      this.witnesses = data.map((witness) => {
        return {
          id: witness.id,
          name: witness.name,
          document: witness.document_number,
          email: witness.email,
        };
      });

      this.count = count;
      this.offset = offset;

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }

  addWitnessesToggle(status: boolean) {
    this.addWitnesses = status;

    if (!status) {
      this.witnessForm.reset();
      this.witness = null;
    }
  }

  async removeWitnesses(id: number) {
    try {
      await this.api.delete({
        route: `api/registration/witnesses/${id}`,
        token: true,
      });

      this.addWitnessesToggle(false);
      this.getData();
      this.toast.show('info', 'Sucesso', 'Testemunha adicionada com sucesso!');
    } catch (error) {
      console.log(error);
    }
  }

  setWitness(witness: Witness) {
    this.witnessForm.patchValue({
      ...witness,
    });
    this.witness = witness;
    this.addWitnessesToggle(true);
  }

  async addNewWitnesss() {
    try {
      const payload = {
        name: this.witnessForm.value.name,
        document_number: this.witnessForm.value.document,
        email: this.witnessForm.value.email,
      };

      if (!this.witness) {
        const emails = this.witnesses.map((witness) => witness.email);
        const documents = this.witnesses.map((witness) => witness.document);

        if (emails.includes(payload.email)) {
          this.toast.show('error', 'Erro', 'Email já cadastrado!');
          return;
        }

        if (documents.includes(payload.document_number)) {
          this.toast.show('error', 'Erro', 'CPF já cadastrado!');
          return;
        }
      }

      const res = !this.witness
        ? await this.api.post({
            route: 'api/registration/witnesses/',
            body: payload,
            token: true,
          })
        : await this.api.put({
            route: `api/registration/witnesses/${this.witness.id}/`,
            body: payload,
            token: true,
          });

      this.addWitnessesToggle(false);
      this.getData();
      this.toast.show('info', 'Sucesso', 'Testemunha adicionada com sucesso!');
    } catch (error) {
      console.log(error);
    }
  }

  changePageData(page: number) {
    this.getData(page);
  }

  setPermissions() {
    const permissions = Object.keys(this.permissionObj).map(
      (key) => `de_can_${key.split('can').join('').toLowerCase()}_witnesses`
    );

    permissions.forEach((permission, idx) => {
      this.permissionObj[Object.keys(this.permissionObj)[idx]] =
        this.authService.verifyPermission(permission);
    });
  }

  setBreadcrumb(): void {
    const canViewDrafts =
      this.authService.verifyPermission('de_can_view_drafts');
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Minutas',
        url: '/app/drafts',
        clickable: canViewDrafts,
      },
      {
        label: 'Testemunhas',
        url: '/app/drafts/witnesses',
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }
}
